// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"194":"4b970a3e3dd59743b5ea","195":"52684a3d346ef5a9481b"}[chunkId] + ".js";
};